import { render, staticRenderFns } from "./AddressListModal.html?vue&type=template&id=35081767&scoped=true&"
import script from "./AddressListModal.vue?vue&type=script&lang=js&"
export * from "./AddressListModal.vue?vue&type=script&lang=js&"
import style0 from "./AddressListModal.scss?vue&type=style&index=0&id=35081767&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35081767",
  null
  
)

export default component.exports